import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Calendar, MapPin } from "lucide-react";
import { PLACEHOLDER_IMAGE } from "@/lib/data";
import { Badge } from "@/components/ui/badge";

export default function Events() {
  const [events, setEvents] = useState([]);
  const [freeOnly, setFreeOnly] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/events", { params: freeOnly ? { free: true } : {} }).then((r) => setEvents(r.data));
  }, [freeOnly]);

  return (
    <div className="max-w-7xl mx-auto px-5 lg:px-8 py-10 min-h-[70vh]">
      <h1 className="font-display text-4xl font-semibold tracking-tight">Local Events</h1>
      <p className="text-slate-500 mt-1 mb-6">Markets, workshops and weekend happenings across Calgary.</p>
      <div className="flex gap-2 mb-8">
        <button data-testid="events-all" onClick={() => setFreeOnly(false)} className={`px-4 py-2 rounded-full text-sm font-medium ${!freeOnly ? "bg-slate-900 text-white" : "bg-[#F3F0EA] text-slate-700"}`}>All Events</button>
        <button data-testid="events-free" onClick={() => setFreeOnly(true)} className={`px-4 py-2 rounded-full text-sm font-medium ${freeOnly ? "bg-orange-500 text-white" : "bg-[#F3F0EA] text-slate-700"}`}>Free Events</button>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {events.map((e, i) => (
          <div key={e.id} data-testid={`event-card-${e.id}`} onClick={() => navigate(`/event/${e.id}`)}
            className="cursor-pointer bg-white rounded-3xl overflow-hidden border border-slate-100 shadow-sm hover:-translate-y-1 hover:shadow-lg transition-all animate-fade-up" style={{ animationDelay: `${i * 50}ms`, opacity: 0 }}>
            <div className="aspect-[16/9] overflow-hidden relative">
              <img src={e.image || e.business?.logo || PLACEHOLDER_IMAGE} alt={e.title} className="w-full h-full object-cover" />
              {e.is_city_event && <Badge className="absolute top-3 left-3 bg-orange-500 text-white rounded-full">Calgary Event</Badge>}
            </div>
            <div className="p-5">
              <div className="flex items-center gap-2 text-sm text-orange-600 font-medium"><Calendar className="w-4 h-4" /> {e.date} · {e.price === 0 ? "Free" : `$${e.price}`}</div>
              <h3 className="font-display text-lg font-semibold mt-1">{e.title}</h3>
              <p className="text-sm text-slate-400 mt-2 flex items-center gap-1"><MapPin className="w-3.5 h-3.5" /> {e.location}</p>
              {(e.business?.name || e.organizer) && <p className="text-xs text-slate-400 mt-1">by {e.business?.name || e.organizer}</p>}
            </div>
          </div>
        ))}
      </div>
      {events.length === 0 && <p className="text-slate-400">No events yet.</p>}
    </div>
  );
}
